import React from 'react';
import { Pressable, Text, View, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { Paprika } from '../../../styles/theme';
import { DietDot } from '../../weekly/v2/primitives/DietDot';
import { useTranslation } from 'react-i18next';

interface Props {
  portions: number;
  fish: number;
  veg: number;
  meat: number;
  onPress: () => void;
}

/**
 * Tappable summary card for the week settings (portions + diet distribution),
 * the mobile entry point into the "Réglages de la semaine" sheet. Spec: wxjX1L.
 */
export function WeekSettingsCard({ portions, fish, veg, meat, onPress }: Props) {
  const { t } = useTranslation();
  return (
    <Pressable style={styles.card} onPress={onPress}>
      <View style={styles.iconTile}>
        <Feather name="sliders" size={16} color={Paprika.textSecondary} />
      </View>

      <View style={styles.middle}>
        <Text style={styles.label}>{t('mealConfig.weekSettingsShort')}</Text>
        <View style={styles.summaryRow}>
          <Feather name="users" size={13} color={Paprika.textSecondary} />
          <Text style={styles.portionsText}>{portions} pers.</Text>
          <Text style={styles.sep}>·</Text>
          <View style={styles.dietItem}><DietDot role="fish" size={7} /><Text style={styles.dietNum}>{fish}</Text></View>
          <View style={styles.dietItem}><DietDot role="vegetarian" size={7} /><Text style={styles.dietNum}>{veg}</Text></View>
          <View style={styles.dietItem}><DietDot role="meat" size={7} /><Text style={styles.dietNum}>{meat}</Text></View>
        </View>
      </View>

      <Feather name="edit-2" size={15} color={Paprika.textMuted} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: Paprika.surfaceLowest,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Paprika.border,
    paddingVertical: 12,
    paddingHorizontal: 14,
  },
  iconTile: {
    width: 38,
    height: 38,
    borderRadius: 10,
    backgroundColor: Paprika.bgSunk,
    justifyContent: 'center',
    alignItems: 'center',
  },
  middle: {
    flex: 1,
    gap: 4,
  },
  label: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 11,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: Paprika.textMuted,
  },
  summaryRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  portionsText: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 13,
    color: Paprika.textPrimary,
  },
  sep: {
    fontSize: 13,
    color: Paprika.textMuted,
    marginHorizontal: 1,
  },
  dietItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
  },
  dietNum: {
    fontFamily: 'Inter-Medium',
    fontSize: 13,
    color: Paprika.textSecondary,
  },
});
